import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminPartnersMetrics() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/partners/metrics").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const fmt = (s) => (s == null ? "—" : (s < 60 ? `${s}s` : `${Math.round(s / 60)}m`));
  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Partner admin</div>
        <h1 className="headline-xl">Metrics</h1>
      </header>
      <div data-testid="admin-partners-metrics" className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">Partner</th><th>Compliance</th><th>Completed</th><th>Cancelled</th><th>Fulfillment</th><th>Handoff</th><th>Revenue</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((m) => (
              <tr key={m.partner_id} className="border-b border-white/5">
                <td className="px-4 py-3 text-lifted-text">{m.business_name}</td>
                <td><span className={`chip ${m.compliance_status === "approved" ? "chip--green" : ""}`}>{m.compliance_status}</span></td>
                <td className="font-anton text-lifted-green">{m.orders_completed}</td>
                <td>{m.orders_cancelled}</td>
                <td>{fmt(m.avg_fulfillment_seconds)}</td>
                <td>{fmt(m.avg_handoff_seconds)}</td>
                <td className="text-lifted-text">${(m.total_revenue_cents/100).toFixed(2)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-lifted-mute">No partners yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
